module.exports = __webpack_public_path__ + "static/media/fidweb-wink-articles_optimized.0794a93b.png";